var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchStroke24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4072 20.8149L19.4073 20.815C19.5891 20.9951 19.8444 21.1 20.1096 21.1C20.705 21.1 21.1 20.6433 21.1 20.1085C21.1 19.8488 21.0154 19.6037 20.8214 19.4116L16.0312 14.6574C17.016 13.4188 17.5957 11.8683 17.5957 10.1791C17.5957 6.17789 14.2948 2.9 10.2479 2.9C6.21065 2.9 2.9 6.16824 2.9 10.1791C2.9 14.1899 6.20099 17.4583 10.2479 17.4583C11.8765 17.4583 13.3746 16.9305 14.5947 16.0387L19.4072 20.8149ZM10.2479 16.0633C6.98964 16.0633 4.31596 13.4046 4.31596 10.1791C4.31596 6.96329 6.98954 4.30443 10.2479 4.30443C13.5062 4.30443 16.1798 6.96329 16.1798 10.1791C16.1798 13.4046 13.5061 16.0633 10.2479 16.0633Z",
    fill: "current",
    stroke: "current",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchStroke24);
export default __webpack_public_path__ + "static/media/Search_Stroke_24.ac65e256786e7071746cf450c9f6457a.svg";
export { ForwardRef as ReactComponent };